import React from "react";
import OrdersTable from "./OrdersTable";

const OrdersOnHold = () => {
  return <OrdersTable type="On Hold" title="Orders on Hold" />;
};

export default OrdersOnHold;
